import type { DisplayCue } from "@expert/contentful/src/types";

export const deselectCue = (devices: DisplayCue[], deviceToDeselect: string): DisplayCue[] => {
    return devices.map((d) =>
        d.name.toLowerCase() === deviceToDeselect.toLowerCase()
            ? { ...d, ...{ detected: false, isDetectedOnPreviousCall: false } }
            : d,
    );
};
